import { Component, Input } from '@angular/core';
import { RoleMatrix } from '../../../../helpers';

@Component({
    selector: 'app-breadcrumb-unit-add',
    templateUrl: './breadcrumb.unit.add.component.html'
})

export class BreadcrumbUnitAddComponent {

    roleMatrix: RoleMatrix;

    @Input() companyId: number;
    @Input() facilityId: number;

    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}
